import React, { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { TextField } from '@crystalservice/crystals-ui/lib/components/inputs/text-field/text-field'
import { Box, IconButton } from '@material-ui/core'
import { Autorenew } from '@material-ui/icons'
import { SetCaptchaStore } from '../../stores/set-captcha-store'

const styles = require('./registration-page.module.scss')

interface SetCaptchaProps {
    clientId: string
    onChange: (answer: string) => void
    onTokenChange: (token: string) => void
    setCaptchaStore?: SetCaptchaStore
}

const buildCaptchaToken = (captchaId: string, answer: string): string => {
    return `${captchaId}#${btoa(encodeURIComponent(answer))}`
}

export const SetCaptcha: React.FC<SetCaptchaProps> = inject(SetCaptchaStore.storeName)(observer(({
    clientId,
    onChange,
    onTokenChange,
    setCaptchaStore,
}) => {
    const {
        answer,
        captchaChallenge,
        captchaId,
        getCaptchaChallenge,
        setAnswer,
    } = setCaptchaStore

    useEffect(() => {
        getCaptchaChallenge(clientId)
    }, [])

    useEffect(() => {
        onTokenChange(buildCaptchaToken(captchaId, answer))
    })

    return (
        <div id="setcaptcha">
            <Box style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                <img
                    style={{ width: 190, height: 60, marginRight: 8 }}
                    src={`data:image/png;base64,${captchaChallenge}`}
                />

                <IconButton onClick={() => getCaptchaChallenge(clientId)}>
                    <Autorenew />
                </IconButton>
            </Box>

            <p id="setcaptcha-label" className={styles.label}>
                <span>Введите текст с картинки</span>
                <span className={styles.required}>{' (обязательно)'}</span>
            </p>

            <TextField
                id="setcaptcha-answer-field"
                className={styles.textField}
                value={answer}
                onValueChange={answer => {
                    setAnswer(answer)
                    onChange(answer)
                }}
            />
        </div>
    )
}))
